import { isArray } from 'util';
import { parseNumber } from '../../utils/number.utils';
import { CamSoftware } from '../cam-software';

export class CamSoftwareBuilder {
  static fromJson(json) {
    return (json)
      ? new CamSoftware(
        parseNumber(json.code),
        json.name,
        json.mimeTypes
      )
      : null;
  }

  static fromList(list) {
    return (isArray(list)) ? list.map(CamSoftwareBuilder.fromJson) : [];
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/cam-software.builder.ts